import { gql } from '@apollo/client';

export default gql`
  query userDashboard {
    space {
      overPlacesLimit
      overInspectionSubjectsLimit
      overInspectionsLimit
      adminRole
      pendingInspectionsTotal
      incomingInspectionsTotal
      overdueInspectionsTotal
      activePlan {
        name
        price
        billingInterval
        placesLimit
        inspectionSubjectsLimit
        inspectionsLimit
      }
    }
    user {
      id
      email
      name
      surname
      inspectorPendingInspectionsTotal
      inspectorIncomingInspectionsTotal
      inspectorOverdueInspectionsTotal
    }
  }
`;
